<template>
  <div class="container-fluid customer-media-container">
    <!-- home img
    <b-row>
      <b-col lg="2" md="5" cols="5" class="mx-auto">
       
      </b-col>
    </b-row> -->
    <!-- title -->
    <b-row>
      <b-col lg="6" offset-lg="3" class="">
        <b-row class="mt-md-4 mt-1">
          <b-col
            xl="2"
            lg="2"
            offset-lg="0"
            md="2"
            offset-md="1"
            class="text-center px-0"
          >
            <img
              class="imageTitleDY"
              src="@/assets/images/doom-yoga/doom-yoga-login-image2.png"
              alt="doomyoga Logo"
            />
          </b-col>
          <b-col
            xl="10"
            lg="10"
            md="8"
            class="d-flex align-items-center text-center"
          >
            <h2 class="welcomeUserHomeH2DY mb-0">Release and Relax</h2>
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="3" class="d-flex align-items-center">
        <router-link
          to="/doom_yoga/events"
          class="
            btn btn-bumblebee btn-doomyoga btn-cutomer-primary
            mt-1 mt-lg-4
          "
          >Book Live Stream Class</router-link
        >
      </b-col>
    </b-row>
    <!-- <MediaSimpleCardList
      list_title="Livestreams"
      :list_items="livestreams_playlists"
      type="movement"
    /> -->
    <MediaSimpleCardList v-if="on_demand_playlists.length>0"
      list_title="On-demand Videos"
      :list_items="on_demand_playlists"
      type="movement"
    />
  </div>
</template>

<script>
import MediaSimpleCardList from "@/components/media_components/MediaSimpleCardList.vue";
import axios from "axios";
export default {
  name: "DoOmYogaCustomerMovement",
  components: { MediaSimpleCardList },
  data() {
    return {
      login_user: window.localStorage.getItem("user"),
      user_name: "",
      livestreams_playlists: [
        {
          id: 1,
          title: " Mental Training",
          duration: "50 Min 30 sec",
          img_src:
            "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
        },
        {
          id: 2,
          title: " Mental Training 2",
          duration: "50 Min 30 sec",
          img_src:
            "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
        },
        {
          id: 3,
          title: " Mental Training 3",
          duration: "50 Min 30 sec",
          img_src:
            "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
        },
        {
          id: 4,
          title: " Mental Training 4",
          duration: "50 Min 30 sec",
          img_src:
            "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
        },
        {
          id: 5,
          title: " Mental Training 3",
          duration: "50 Min 30 sec",
          img_src:
            "https://images.unsplash.com/photo-1565301660306-29e08751cc53?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
        },
        {
          id: 6,
          title: " Mental Training 4",
          duration: "50 Min 30 sec",
          img_src:
            "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
        },
        {
          id: 4,
          title: " Mental Training 4",
          duration: "50 Min 30 sec",
          img_src:
            "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
        },
        {
          id: 5,
          title: " Mental Training 3",
          duration: "50 Min 30 sec",
          img_src:
            "https://images.unsplash.com/photo-1565301660306-29e08751cc53?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
        },
        {
          id: 6,
          title: " Mental Training 4",
          duration: "50 Min 30 sec",
          img_src:
            "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
        },
      ],
      on_demand_playlists: [],
    };
  },
  mounted() {
    let formData = new FormData();
    formData.append("media_library", "video_library");
    axios
      .post("media/library/categories", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          client: "DY",
          Authorization:
            "Bearer " +
            JSON.parse(window.localStorage.getItem("user")).access_token,
        },
      })
      .then((response) => {
        console.log(response);
        this.on_demand_playlists = response.data;
      });
  },
};
</script>

<style scoped::v-deep >
</style>


// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Movement/Index.vue